import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useI18n } from "@/context/I18nContext";

export const REPRISE_BRANDS = {
  van: ["Fautras", "Ifor Williams", "Böckmann", "Cheval Liberté", "Humbaur"],
  fourgon: ["Fautras", "Ifor Williams", "Böckmann", "Debon", "Barbot", "Humbaur"],
};

export const REPRISE_TEXT = [["modele", "Modèle"], ["annee", "Année"], ["immat", "Immatriculation"], ["ptac", "F2 (PTAC)"]];
export const REPRISE_CHOICES = [
  ["places", "Nbre de places", ["1 place", "1,5 place", "2 places droit", "2 places diagonale", "3 places diagonale", "4 places diagonale"], "van"],
  ["plancher_type", "Type de plancher", ["Bois", "Alu", "Polyéthylène"]],
  ["essieux", "Essieux", ["1 essieu", "2 essieux"]],
  ["plancher", "État du plancher", ["À changer", "À réparer", "Bon état", "Refait à neuf"]],
  ["panneaux_type", "Type panneaux de côté", ["Bois", "Alu", "Polyester", "Autre"]],
  ["panneaux", "État des panneaux de côté", ["À changer", "À réparer", "Bon état"]],
  ["carrosserie", "État carrosserie", ["Très mauvais état", "Mauvais état", "Bon état", "Très bon état"]],
  ["electricite", "Feux et électricité", ["Faisceau et feu(x) à réparer/remplacer", "Feu(x) à réparer/remplacer", "Électricité fonctionne"]],
  ["freins", "Freins", ["À réviser", "Révisé et en bon état"]],
  ["gardeboue", "Garde-boue", ["À remplacer", "En bon état"]],
  ["pneus", "Pneus", ["À remplacer", "En bon état", "Neuf"]],
  ["tapis", "Tapis", ["À remplacer", "En bon état"], "van"],
  ["structure", "Structure et châssis", ["À réparer/remplacer", "En bon état"]],
  ["ouvertures", "Pont / portes / ouvertures", ["À réparer/remplacer", "En bon état"]],
  ["attelage", "Attelage", ["À remplacer/réparer", "Bon état"]],
];
export const REPRISE_DIMS = [["longueur_int", "Longueur intérieure (cm)"], ["largeur_int", "Largeur intérieure (cm)"], ["hauteur_int", "Hauteur intérieure (cm)"]];
export const REPRISE_EXTRAS = [
  ["grands_chevaux", "Grands chevaux", ["van"]],
  ["fleche_caleche", "Flèche calèche", ["van", "fourgon"]],
  ["ouverture_estivale", "Ouverture estivale", ["van", "fourgon"]],
  ["sortie_avant", "Sortie avant", ["van"]],
  ["toit", "Toit", ["van", "fourgon"]],
  ["echelle_galerie", "Échelle + galerie", ["van", "fourgon"]],
  ["jante_alu", "Jantes alu", ["van", "fourgon"]],
];
export const REPRISE_KEYS = ["marque", ...REPRISE_TEXT.map(([k]) => k), ...REPRISE_CHOICES.map(([k]) => k), ...REPRISE_DIMS.map(([k]) => k), ...REPRISE_EXTRAS.map(([k]) => k), "prix_saisi"];
// État par défaut = meilleur état si rien n'est choisi (« Refait à neuf » n'est jamais un défaut)
export const REPRISE_BEST = Object.fromEntries(REPRISE_CHOICES.filter(([k]) => !["places", "essieux", "plancher_type", "panneaux_type"].includes(k)).map(([k, , opts]) => { const o = opts.filter((x) => x !== "Refait à neuf"); return [k, o[o.length - 1]]; }));

export const RepriseChoice = ({ label, options, value, onChange, testid, placeholder, required }) => {
  const { t } = useI18n();
  return (
  <div>
    <span className="text-[11px] text-muted-foreground">{t(label)}{required && <span className="text-destructive"> *</span>} :</span>
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="h-8 text-xs mt-0.5" data-testid={testid}><SelectValue placeholder={placeholder || t("Choisir…")} /></SelectTrigger>
      <SelectContent>
        {options.map((o) => <SelectItem key={o} value={o} className="text-xs">{t(o)}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
  );
};

// Brand picker for a trade-in: list per vehicle type + "Autre (précisez)" free text
export const RepriseBrand = ({ type, value, other, onChange, testid, list }) => {
  const { t } = useI18n();
  const brands = list || REPRISE_BRANDS[type];
  if (!brands) {
    return <Input value={value} onChange={(e) => onChange({ marque: e.target.value, marqueAutre: true })} data-testid={testid} className="h-8 text-xs mt-0.5" />;
  }
  const choice = !other && brands.includes(value) ? value : (other || value ? "__autre__" : "");
  return (
    <div className="space-y-1 mt-0.5">
      <Select value={choice} onValueChange={(v) => onChange(v === "__autre__" ? { marque: "", marqueAutre: true } : { marque: v, marqueAutre: false })}>
        <SelectTrigger className="h-8 text-xs" data-testid={testid}><SelectValue placeholder={t("Choisir…")} /></SelectTrigger>
        <SelectContent>
          {brands.map((b) => <SelectItem key={b} value={b} data-testid={`${testid}-opt-${b}`}>{b}</SelectItem>)}
          <SelectItem value="__autre__" data-testid={`${testid}-opt-autre`}>{t("Autre (précisez)")}</SelectItem>
        </SelectContent>
      </Select>
      {choice === "__autre__" && (
        <Input value={value} placeholder={t("Précisez la marque")} onChange={(e) => onChange({ marque: e.target.value, marqueAutre: true })}
          data-testid={`${testid}-autre`} className="h-8 text-xs" />
      )}
    </div>
  );
};
